import { AxiosInstance } from 'axios';
import { throwApiError } from 'src/api/utils';

import { TRawPadPreparationWithRSE } from './types';

export class WellPadPreparationApi {
  private readonly agent: AxiosInstance;

  constructor(agent: AxiosInstance) {
    this.agent = agent;
  }

  async fetchPadPreparation(planVersionId: number, signal?: AbortSignal): Promise<TRawPadPreparationWithRSE[]> {
    try {
      const { data } = await this.agent.get('/pad-preparation/list', {
        params: {
          planVersionId,
        },
        signal,
      });

      return data;
    } catch (e) {
      throwApiError(e);
    }
  }
}
